const profile = {
    name: 'Nome',
    avatar: 'Avatar',
    givenName: 'Nome próprio',
    familyName: 'Apelido',
    middleName: 'Nome do meio',
    fullName: 'Nome completo',
    nickname: 'Alcunha',
    preferredUsername: 'Nome de utilizador preferido',
    profile: 'Perfil',
    website: 'Website',
    gender: 'Género',
    birthdate: 'Data de nascimento',
    zoneinfo: 'Fuso horário',
    locale: 'Localização',
    address: {
        formatted: 'Endereço',
        streetAddress: 'Morada',
        locality: 'Cidade',
        region: 'Distrito/Província',
        postalCode: 'Código postal',
        country: 'País',
    },
};
export default Object.freeze(profile);
